













import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { difference } from 'lodash'
import Button from '@/apps/open/components/Button'
import { ACCESS_KNOW_URL } from '@/apps/open/constants'
import { getIpWhitelist, appendIPWhitelist, removeIPWhitelist } from '@/apps/open/services/app'
import EditIpWhitelistDialogBody from '@/apps/open/components/DialogBodys/app/EditIpWhitelist.vue'
import { onRequestError } from '@/apps/open/utils'

@Component({
  components: {
    Button
  }
})
export default class IPWhitelistSetting extends Vue {
  IP_URL = ACCESS_KNOW_URL
  ipList: string[] = []
  submitting = false
  errorMsg = ''
  newIpList = ''

  get appId () {
    return this.$route.params.id
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  setIpWhitelist () {
    this.$dialog.show({
      title: 'IP白名单配置',
      body: EditIpWhitelistDialogBody,
      bodyProps: {
        value: this.ipList,
        onCancel: this.$dialog.close,
        onOk: this.submitIpWhitelist
      }
    })
  }

  viewIpWhitelist () {
    this.$dialog.show({
      title: 'IP白名单配置',
      body: `<div style="max-height: 300px; overflow: auto;">${this.ipList.join('<br>')}</div>`,
      buttons: [
        { text: '取消' },
        { text: '修改', type: 'primary', fn: this.setIpWhitelist }
      ]
    })
  }

  async submitIpWhitelist (value: string) {
    this.submitting = true
    const newIpList = value.split('\n').map((i: string) => i.trim()).filter((i: string) => i !== '')
    if (this.ipList.join('\n') === newIpList.join('\n')) {
      this.$message.success('IP白名单保存成功')
      this.$dialog.close()
      return
    }
    const addList = difference(newIpList, this.ipList)
    const removeList = difference(this.ipList, newIpList)
    const requestList = []
    if (addList.length) {
      requestList.push(appendIPWhitelist(this.appId, addList))
    }
    if (removeList.length) {
      requestList.push(removeIPWhitelist(this.appId, removeList))
    }
    try {
      await Promise.all(requestList)
      this.load()
      this.$message.success('IP白名单保存成功')
    } catch (error) {
      onRequestError(error)
    }
    this.$dialog.close()
  }

  async load () {
    try {
      const res = await getIpWhitelist(this.appId)
      this.ipList = res.data.object_array.map((item: any) => item.ip)
    } catch (error) {
      onRequestError(error)
    }
  }

  mounted () {
    this.load()
  }
}
